import {ToggleButtonGroup, InputLabel, MenuItem, Select, FormControlLabel, Switch, Box} from "@mui/material";
import {useEffect, useState} from "react";
import {SelectChangeEvent} from "@mui/material/Select";
import {GraphType, AvaiGraphTypes_f, AvaiGraphTypesAnimals_f} from "../../../interfaces/traffic_accidents/GraphType";
import TGraphContent from "../../../components/Graphs/TGraphContent";
import AnimatedMonthlyChart from "../../../components/Graphs/AnimatedMonthlyChart";
import WeeklyChart from "../../../components/Graphs/WeeklyChart";
import { useTranslation } from "react-i18next";
import image from '../../../assets/css/images/police.jpg';
import PageForm from "../../../components/PageHeader/PageForm";
import { Button } from "../../../components/StyleComponents/StyleComponents";


export default function TGraphs() {
    const {t} = useTranslation("traffic");
    
    // State for regular traffic accidents
    const [graphOption, SetGraphOption] = useState<string[]>(["0"]);
    const [graphTypes, SetGraphTypes] = useState<GraphType[]>(AvaiGraphTypes_f(t));
    const [currentGraphType, SetCurrentGraphType] = useState<GraphType>(graphTypes[0]);
    
    // State for animal accidents
    const [graphOptionAnimals, SetGraphOptionAnimals] = useState<string[]>(["0"]);
    const [graphTypesAnimals, SetGraphTypesAnimals] = useState<GraphType[]>(AvaiGraphTypesAnimals_f(t));
    const [currentGraphTypeAnimals, SetCurrentGraphTypeAnimals] = useState<GraphType>(graphTypesAnimals[0]);
    
    const [toggleDN, setToggleDN] = useState(true); 
    const [toggleZV, setToggleZV] = useState(true); 
    const [liveMode, setLiveMode] = useState(false); 
    
    const OnChangeGrahpOptionHandler = (event : SelectChangeEvent<typeof graphOption>) => {
        const {target: {value}} = event;
        SetGraphOption(typeof value === "string" ? value.split(",") : value);
    }
    
    const OnChangeGrahpOptionAnimalsHandler = (event : SelectChangeEvent<typeof graphOptionAnimals>) => {
        const {target: {value}} = event;
        SetGraphOptionAnimals(typeof value === "string" ? value.split(",") : value);
    }
    
    const handleToggleDNMain = () => {
        if (!toggleDN) {
            setToggleDN(!toggleDN);
        }
        if (!toggleZV) {
            setToggleZV(!toggleZV);
        }
    };

    const handleZVClick = () => {
        setToggleZV(!toggleZV);
        if (!toggleDN) {
            setToggleDN(!toggleDN);
        }
    };
    
    useEffect(() => {
        SetCurrentGraphType(graphTypes[parseInt(graphOption[0])]);
    }, [graphOption]);
    useEffect(() => {
        SetCurrentGraphType(graphTypes[parseInt(graphOption[0])]);
    }, [graphTypes]);
    
    useEffect(() => {
        SetCurrentGraphTypeAnimals(graphTypesAnimals[parseInt(graphOptionAnimals[0])]);
    }, [graphOptionAnimals]);
    useEffect(() => {
        SetCurrentGraphTypeAnimals(graphTypesAnimals[parseInt(graphOptionAnimals[0])]);
    }, [graphTypesAnimals]);

    useEffect(function() {
        SetGraphTypes(AvaiGraphTypes_f(t));  
        SetGraphTypesAnimals(AvaiGraphTypesAnimals_f(t));
    }, [t('locale')]);

  return (
    <PageForm  label={(toggleDN && toggleZV) ? t("TGraphs.nadpis") : t("TGraphs.nadpisSoZverou")} image={image}>
    <div className='box-12'>
        <div className='box-12 py-2 text-center'>
            <ToggleButtonGroup>
                <Button onClick={handleToggleDNMain} style={{margin: '0px'}}>{t("Search.nadpisNehody")}</Button>
                <Button className={toggleZV ? 'main-button-zver' : ``} onClick={handleZVClick} style={{margin: '0px'}}>{t("Search.nadpisZverOnly")}</Button>
            </ToggleButtonGroup>
        </div>

        {(toggleDN && toggleZV) ? (
            <div>
                <div>
                    <InputLabel id="GraphOptionLabel">{t("TGraphs.graf")}</InputLabel>
                    <Select
                        value={graphOption}
                        onChange={OnChangeGrahpOptionHandler}
                        labelId="GraphOptionLabel"
                        label="Graf"
                        autoWidth
                    >
                        {
                            graphTypes.map((graphType, i) => <MenuItem key={graphType.key} value={i.toString()}>{graphType.name}</MenuItem>)
                        }
                    </Select>
                </div>
                <TGraphContent endpoint={currentGraphType.endpoint} name={currentGraphType.name} graphData={currentGraphType.graphData}/>
            </div>
        ) : (
            <div>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    {!liveMode && (
                        <div>
                            <InputLabel id="GraphOptionAnimalsLabel">{t("TGraphs.graf")}</InputLabel>
                            <Select
                                value={graphOptionAnimals}
                                onChange={OnChangeGrahpOptionAnimalsHandler}
                                labelId="GraphOptionAnimalsLabel"
                                label="Graf"
                                autoWidth
                            >
                                {
                                    graphTypesAnimals.map((graphType, i) => <MenuItem key={graphType.key} value={i.toString()}>{graphType.name}</MenuItem>)
                                }
                            </Select>
                        </div>
                    )}
                    
                    <FormControlLabel
                        control={
                            <Switch 
                                checked={liveMode}
                                onChange={(e) => setLiveMode(e.target.checked)}
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: '#ff4444',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: '#ff4444',
                                    },
                                }}
                            />
                        }
                        label={t('Traffic.liveChart')}
                        labelPlacement="start"
                        sx={{ 
                            color: 'inherit',
                            fontWeight: 'normal',
                            marginLeft: liveMode ? 'auto' : 0
                        }}
                    />
                </Box>
                
                {!liveMode ? (
                    <div>
                        <TGraphContent endpoint={currentGraphTypeAnimals.endpoint} name={currentGraphTypeAnimals.name} graphData={currentGraphTypeAnimals.graphData} isAnimals={true} minYear={currentGraphTypeAnimals.minYear}/>
                        <div style={{ marginTop: '120px', marginBottom: '20px', textAlign: 'center' }}>
                            <h3 style={{ margin: 0, color: '#333', fontSize: '30px', fontWeight: 'bold' }}>
                                {t('Traffic.chartTitleTimeGranularity')}
                            </h3>
                        </div>
                        <WeeklyChart isVisible={true} />
                    </div>
                ) : (
                    <AnimatedMonthlyChart isVisible={true} />
                )}
            </div>
        )}
    </div>
    </PageForm>
  );
}
